import { render, staticRenderFns } from "./RegistrationApp.vue?vue&type=template&id=6d57e83b&"
import script from "./RegistrationApp.vue?vue&type=script&lang=ts&"
export * from "./RegistrationApp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports